<template>
  <popup
    :close-action="closeActionClicked"
    class="balance-vs-cashflow-popup"
    :title="'איך התזרים השפיע על יתרת העו״ש?'"
    :buttons="[{ title: 'חזרה לתזרים', variant: 'secondary', action: closeActionClicked }]">
    <template v-slot:content>
      <div class="explanation-text">
        <div>
          <div class="bold green">החודש הסתיים בתזרים חיובי?</div>
          <div>מעולה 🙂 זה אומר שנכנס החודש <span class="bold">יותר כסף</span> ממה שיצא.</div>
        </div>
        <div>
          <div class="bold">מה זה אומר על העו״ש?</div>
          הכסף שנשאר בצד החודש מגדיל את היתרה בבנק 💪 בתכל'ס, <span class="bold">תזרים חיובי = העו״ש גדל</span>.
        </div>
        <div>
          <div class="bold red">ואם החודש הסתיים בתזרים שלילי? </div>
          זה אומר שנכנס החודש <span class="bold">פחות כסף </span>
          ממה שיצא 😔 זאת אומרת, היתרה בבנק תקטן. בתכל'ס, <span class="bold">תזרים שלילי = העו״ש קטן</span>.
        </div>
        <div>
          <span class="bold">חשוב לשים ❤️</span>
          שאם הגדרת הוצאות או הכנסות כ<span class="bold">לא תזרימיות</span>, הן ישפיעו על העו״ש אבל לא יופיעו בתזרים.
        </div>
        <div>אם יש שאלות נוספות צוות המומחים שלנו ישמח לעזור לך בצ׳אט 💬
        </div>
      </div>
      <thumbs class="thumbs" v-on:thumbsup="thumbsUp" v-on:thumbsdown="thumbsDown" question-text="האם זה עזר לך להבין?"></thumbs>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../Segment';
import Thumbs from '../../../../../../../../base-components/Thumbs.vue';

export default {
  name: 'BalanceVsCashflowPopup',
  components: {
    Thumbs,
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('ExplainBalanceVsCashflowPopupShown');
  },
  methods: {
    closeActionClicked() {
      Segment.trackUserInteraction('ExplainBalanceVsCashflowPopupClosed');
      this.$emit('close');
    },
    thumbsUp() {
      Segment.trackUserInteraction('ExplainBalanceVsCashflowPopup_ThumbsUp');
    },
    thumbsDown() {
      Segment.trackUserInteraction('ExplainBalanceVsCashflowPopup_ThumbsDown');
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .balance-vs-cashflow-popup {
    .explanation-text {
      font-size: 16px;
      line-height: 1.5;
      > div {
        margin-top: 24px;
      }
      .bold {
        font-weight: bold;
      }
      .green {
        color: $riseup_green;
      }
      .red {
        color: $riseup_coral;
      }
    }

    .thumbs {
      margin-top: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/BalanceVsCashflowPopup.vue